import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag: (
      command: string,
      ...args: any[]
    ) => void;
  }
}

const GA_MEASUREMENT_ID = 'G-XHSHYPK0K6';

export const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views on route change
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

// Helper function to track custom events
export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Helper function to track conversions
export const trackConversion = (
  conversionLabel: string,
  value?: number,
  currency?: string
) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      send_to: `${GA_MEASUREMENT_ID}/${conversionLabel}`,
      value: value,
      currency: currency || 'USD',
    });
  }
};

// Track user sign ups
export const trackSignUp = (method: string) => {
  trackEvent('sign_up', 'engagement', method);
};

// Track purchases
export const trackPurchase = (
  value: number,
  currency: string = 'USD',
  items?: any[]
) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'purchase', {
      currency: currency,
      value: value,
      items: items,
    });
  }
};

// Track search queries
export const trackSearch = (searchTerm: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'search', {
      search_term: searchTerm,
    });
  }
};

export default GoogleAnalytics;